import {cssBreakpointFactory, cssVariableFactory} from "@rw/linaria_styles";
import {carsTheme} from "@rw/themes";

export const getThemeVariable = cssVariableFactory<typeof carsTheme>();
export const getThemeBreakpoint = cssBreakpointFactory(carsTheme.breakpoints);
export const getThemeBreakpointCorrect = cssBreakpointFactory(carsTheme.breakpoints_correct);

const transformThemeToCssVariables = (theme: Object, base = "--"): string =>
    Object.entries(theme).reduce((css, [key, value]) => {
        const newBase = base + `${key}`;
        if (typeof value !== "object") {
            return css + newBase + `: ${value};\n`;
        }
        return css + transformThemeToCssVariables(value, newBase + "-");
    }, ``);

export const getThemeVariableList = transformThemeToCssVariables(carsTheme);
